import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-3" }

import { Component } from "vue"
import TriggerCard from "@/components/workflows/TriggerCard.vue"
import ContactActivityTriggerSidebar from "@/components/workflows/sidebar/trigger/ContactActivityTriggerSidebar.vue"
import ScheduleTriggerSidebar from "@/components/workflows/sidebar/trigger/schedule/ScheduleTriggerSidebar.vue"
import CMSListingActivityTriggerSidebar from "@/components/workflows/sidebar/trigger/CMSListingActivityTriggerSidebar.vue"

interface Props {
    modelValue: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'EnrolmentTriggersSidebar',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "changeAction"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

function changeAction(sidebarComponent: Component) {
    emit("changeAction", {
        sidebarComponent,
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-lg leading-7 font-medium" }, "Choose how to trigger this workflow:", -1)),
    _createVNode(TriggerCard, {
      title: "Contact Activity",
      example: "Automatically enroll contacts that are tagged with hot lead.",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (changeAction(ContactActivityTriggerSidebar)))
    }),
    _createVNode(TriggerCard, {
      title: "Preset Schedule",
      example: "Every Monday at 9 AM, enroll all leads of a certain status into a nurture workflow.",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (changeAction(ScheduleTriggerSidebar)))
    }),
    _createVNode(TriggerCard, {
      title: "CMS Activity",
      example: "Enroll every contact who requests a property tour.",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (changeAction(CMSListingActivityTriggerSidebar)))
    })
  ]))
}
}

})